export default {
	getTimeAnalyzed(): number {
		const difference = Math.floor(Math.random() * 6) + 1;
		return difference;
	}
}